import { Component, OnInit, Input } from '@angular/core';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { NavController } from '@ionic/angular';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { Router } from '@angular/router';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';

@Component({
  selector: 'khushi-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input()
  pageTitle: string;
  currentPage: string;
  ShowBackButton: any = false;
  constructor(public actionVal: ActionlistenService, public cmndecl: CommonDeclarationService, public api: RestapiService, public router: Router, public cmndef: CommonDefinitionService, public navCtrl: NavController) {
    // this.currentPage = sessionStorage.CurrentPage;
    // console.log("this.currentPage  " + this.currentPage);
    // if (this.cmndef.BackenablePages.indexOf(sessionStorage.CurrentPage) != -1) {
    //   this.ShowBackButton = true;
    // } else {
    //   this.ShowBackButton = false;
    // }
  }

  ngOnInit() {

  }

  // navigateBack() {
  //   if(this.cmndef.TrakcerForm.indexOf(this.router.url) != -1){
  //     console.log(this.router.url);
  //     if(this.router.url == "/va/emailupdate" || this.router.url == "/va/mobileupdate") {
  //       this.cmndef.emailScreenRedirection = false;
  //       this.cmndef.mobileScreenRedirection = false;
  //     }
  //     this.api.clickenventcap("back_"+this.cmndef.TrakcerFromValue[this.router.url]);
  //   }
  //   if (this.router.url == "/verifyOtpPassword") {
  //     this.cmndecl.functionCall='otpback'
  //     sessionStorage.CurrentPage = this.cmndef.Backtowhere[this.currentPage];
  //     this.navCtrl.navigateRoot(this.cmndef.Backtowhere[this.currentPage])
  //   }else if (this.cmndef.Backtowhere[this.currentPage] == "/va/chat") {
  //     this.cmndecl.functionCall = "talkback";
  //     sessionStorage.CurrentPage = this.cmndef.Backtowhere[this.currentPage];
  //     this.navCtrl.navigateRoot(this.cmndef.Backtowhere[this.currentPage])
  //   } else {
  //     sessionStorage.CurrentPage = this.cmndef.Backtowhere[this.currentPage];
  //     this.navCtrl.navigateBack(this.cmndef.Backtowhere[this.currentPage])
  //   }

  // }

}
